export class DeleteCorporateDataEvent {}
